<template>
    <div style="padding-top: 40px">
        <div>
            <p class="navadno-besedilo" v-if="kontaktniPodatki !== null">
                Pregled konfiguracije telefonskih številk na modemu. <br>
                Za spremembo ali prestavitev telefonske številke na drugi vhod,
                nas prosim pokličite na {{kontaktniPodatki.T2_SUPPORT_TEL_ST}}.
            </p>
        </div>
      <div v-if="!povezanoVOmrezje" class="obvestilo-splosno">
        Naprava ni priklopljena v omrežje.
        Prosimo, preverite ustreznost priklopa naprave ali nas pokličite na 064 064 064.
      </div>
        <div style="padding-top: 30px" v-if="seznamStevilk.length > 0">
            <table>
                <tr v-for="(data,index) in seznamStevilk">
                    <td>
                        Telefonska številka {{index}}:
                    </td>
                    <td style="padding-left: 50px">
                        <span v-if="data.Enabled === 'Enabled'">
                            <b>
                                {{data.Number}}
                            </b>
                        </span>
                        <div v-else>
                            <b>
                                (brez)
                            </b>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
      <div v-if="seznamStevilk.length === 0" class="obvestilo-konfigurirana-tel-stevilka">
        Na mrežni opremi ni konfiguriranih telefonskih številk.
      </div>
    </div>
</template>
<script>
    import {Select, Option, Collapse, CollapseItem} from 'element-ui'
    import ClientAgent from '../../../../../assets/js/clientAgent.js'
    import {KontaktniPodatkiEnum} from '../../../../../assets/js/Enum/KontaktniPodatkiEnum.js'
    export default {
      name: 'voip',
      props: {
        idIzbranaOprema: {},
        povezanoVOmrezje: false
      },
      data () {
        return {
          title: 'Telefonija',
          clientAgent: null,
          seznamStevilk: [],
          kontaktniPodatki: null
        }
      },
      components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem
      },
      mounted () {
        this.clientAgent = new ClientAgent()
        this.kontaktniPodatki = KontaktniPodatkiEnum
        this.getVoipInfo()
      },
      methods: {
        getVoipInfo () {
          if (this.povezanoVOmrezje) {
            let param = ['idOprema=' + this.idIzbranaOprema]
            this.clientAgent.postWsRequest(
              this,
              'tr069/voip/info',
              param,
              null,
              'setVoipInfo',
              'showErrorMsg')
          }
        },
        setVoipInfo (podatki) {
          if (podatki !== null && podatki.data.VoIP !== undefined) {
            this.seznamStevilk = Object.keys(podatki.data.VoIP).map(function (key) {
              return podatki.data.VoIP[key]
            })
          }
        }
      },
      watch: {
        idIzbranaOprema: function () {
          if (this.idIzbranaOprema !== null) {
            this.getVoipInfo()
          }
        }
      }
    }
</script>
<style scoped src="../../../../../../static/css/Nastavitve/MreznaOprema/voip.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/tr069/Voip.vue